module.exports = __webpack_public_path__ + "static/media/Unicorn Girl.8eaab943.jpg";